module.exports = __webpack_public_path__ + "img/fullscreen_icon.8fd5ddec.svg";